import { combineReducers } from "redux";
import signedinReducer from "./signedinReducer";

const rootReducer = combineReducers({
  signedinuserobject: signedinReducer
});

export default rootReducer;
